<router-outlet></router-outlet>
@if (loaderService.state()) {
    <app-loader [guestLoader]="true" />
}
